export const MODULE_PERMISSION_KEYS = {
  dashboard: null,
  accessControl: 'access',
  riskPolicy: 'risk',
  users: 'users',
  transactions: 'transactions',
  settlementOps: 'settlement',
  queueJobs: 'queues',
  sos: 'sos',
  adjustments: 'adjustments',
  config: 'config',
  serviceReports: 'services',
  blockchainOps: 'services',
};

export function buildPermissionMap(permissions = []) {
  return permissions.reduce((acc, permission) => {
    if (permission?.permission_code) {
      acc[permission.permission_code] = permission;
    }

    if (permission?.module) {
      if (!acc.modules) {
        acc.modules = {};
      }

      if (!acc.modules[permission.module]) {
        acc.modules[permission.module] = [];
      }

      acc.modules[permission.module].push(permission);
    }

    return acc;
  }, {});
}

export function isModuleAllowed(permissionMap, moduleName, isSuperAdmin = false) {
  if (!moduleName || isSuperAdmin) {
    return true;
  }

  const modulePermissions = permissionMap?.modules?.[moduleName] || [];
  return modulePermissions.some((permission) => permission.allowed);
}

export function isPermissionAllowed(permissionMap, permissionCode, isSuperAdmin = false) {
  if (!permissionCode || isSuperAdmin) {
    return true;
  }

  return Boolean(permissionMap?.[permissionCode]?.allowed);
}
